import { AxiosPromise } from 'axios';
import { http } from 'services';
import * as Types from './types';

export const list = (): AxiosPromise<Types.IApi.List.Response> =>
  http.request.get('/api/teams');

export const myTeams = (): AxiosPromise<Types.IApi.List.Response> =>
  http.request.get('/api/teams/my');

// Candidate portal: every class the user belongs to across ALL their orgs. No
// X-Organization-Id is sent — the endpoint aggregates by the caller's own
// memberships, so it must not be pinned to a single active org.
export const myClasses = (): AxiosPromise<Types.IApi.MyClasses.Response> =>
  http.request.get('/api/teams/my-classes');

export const single = (id: string): AxiosPromise<Types.IApi.Single.Response> =>
  http.request.get(`/api/teams/${id}`);

export const overview = (): AxiosPromise<Types.IApi.Overview.Response> =>
  http.request.get('/api/teams/overview');

export const stats = (id: string): AxiosPromise<Types.IApi.Stats.Response> =>
  http.request.get(`/api/teams/${id}/stats`);

export const activity = (id: string): AxiosPromise<Types.IApi.Activity.Response> =>
  http.request.get(`/api/teams/${id}/activity`);

export const create = (data: Types.IApi.Create.Request): AxiosPromise<Types.IApi.Create.Response> =>
  http.request.post('/api/teams', data);

export const update = (id: string, data: Types.IApi.Update.Request): AxiosPromise<Types.IApi.Update.Response> =>
  http.request.patch(`/api/teams/${id}`, data);

export const remove = (id: string): AxiosPromise<void> =>
  http.request.delete(`/api/teams/${id}`);

export const addMember = (
  teamId: string,
  data: Types.IApi.AddMember.Request
): AxiosPromise<Types.IApi.AddMember.Response> =>
  http.request.post(`/api/teams/${teamId}/members`, data);

export const bulkAddMembers = (
  teamId: string,
  data: Types.IApi.BulkAddMembers.Request
): AxiosPromise<Types.IApi.Single.Response> =>
  http.request.post(`/api/teams/${teamId}/members/bulk`, data);

export const updateMemberRole = (
  teamId: string,
  userId: string,
  data: Types.IApi.UpdateMemberRole.Request
): AxiosPromise<void> =>
  http.request.patch(`/api/teams/${teamId}/members/${userId}`, data);

export const removeMember = (teamId: string, userId: string): AxiosPromise<void> =>
  http.request.delete(`/api/teams/${teamId}/members/${userId}`);

export const search = (params: Types.IApi.Search.Params): AxiosPromise<Types.IApi.Search.Response> =>
  http.request.get('/api/teams/search', { params });

// ─── Self-service join link + code ─────────────────────────────────────────

export const getJoinToken = (
  teamId: string,
): AxiosPromise<Types.IApi.JoinToken.Get.Response> =>
  http.request.get(`/api/teams/${teamId}/join-token`);

export const generateJoinToken = (
  teamId: string,
): AxiosPromise<Types.IApi.JoinToken.Generate.Response> =>
  http.request.post(`/api/teams/${teamId}/join-token`);

export const revokeJoinToken = (teamId: string): AxiosPromise<void> =>
  http.request.delete(`/api/teams/${teamId}/join-token`);

// Public — resolve a link token or short code to team + org name.
export const validateJoinToken = (
  token: string,
): AxiosPromise<Types.IApi.JoinToken.Validate.Response> =>
  http.request.get(`/api/teams/join/${encodeURIComponent(token)}/validate`);

// Authenticated — join the team (and the org as a candidate if not a member).
export const joinByToken = (
  token: string,
): AxiosPromise<Types.IApi.JoinToken.Join.Response> =>
  http.request.post('/api/teams/join', { token });
